import React from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import { useState, useContext, useEffect, useRef } from "react";
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import './navbar2.css';
import BASE_URL from '../context/AppConfig';
import IMG_URL from '../context/AppImgConfig';

function Navbar2() {

    const { user, setUser, is_admin } = useContext(AuthContext);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const [info, setInfo] = useState([])

    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setOpen(!open);
    const [timezone, setTimezone] = useState("");

    useEffect(() => {
        const getTimeZoneLabel = () => {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const offsetMinutes = new Date().getTimezoneOffset();
            const hours = Math.floor(Math.abs(offsetMinutes) / 60);
            const mins = Math.abs(offsetMinutes) % 60;
            const sign = offsetMinutes <= 0 ? "+" : "-";
            return `${tz} GMT ${sign}${hours}:${mins.toString().padStart(2, "0")}`;
        };

        setTimezone(getTimeZoneLabel());
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);

    }, []);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOpen(false);
        }
    };

    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [uploadMessage, setUploadMessage] = useState("");

    const handleFileChange = (e) => {
        const image = e.target.files[0];
        if (image) {
          setFile(image);
          setPreviewUrl(URL.createObjectURL(image));
          handleUpload(image); // directly upload when selected
          console.log(previewUrl);
        }
      };
      const token = localStorage.getItem('token');
    const handleUpload = async () => {
        if (!file) return alert("Please select an image");

        const formData = new FormData();
        formData.append("profile_picture", file);

        try {
            const response = await axios.put(`${BASE_URL}/update-profile-picture/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`, // adjust auth if needed
                },
            });
            console.log(response.data);
            setUploadMessage("Upload Successful!");
        } catch (error) {
            console.error(error);
            setUploadMessage("Upload Failed.");
        }
    };

    const fileInputRef = useRef(null);

    const handleImageClick = () => {
        fileInputRef.current.click(); // Trigger the hidden file input
      };
      const fetchProfilePicture = async () => {
        try {
          const res = await axios.get(`${BASE_URL}/update-profile-picture/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          setPreviewUrl(res.data.profile_picture);
          console.log(res.data.profile_picture);
        } catch (err) {
          console.error(err);
        }
      };

      useEffect(()=>{
        fetchProfilePicture();
      },[previewUrl,file, user]);

    useEffect(() => {
        axios.get(`${BASE_URL}/offices/`)
            .then((res) => {
                setInfo(res.data);
            })
            .catch((err) => {
                console.log(err)
            });
            
            
              
    }, []);


    
    

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user"); // Remove user from localStorage
        setUser(null);
        navigate('/signin'); // Redirect to login page
    };

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };


    return (
        <div className='navcontainer'>


            <div className="top-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-12">
                            <div className="logo">
                                <a href="/">

                                    <img src="img/logo2.png" alt="Logo" />
                                </a>
                                
                            </div>
                            
                            
                        </div>
                        
                        <div className="col-lg-8 col-md-7 d-none d-lg-block">
                            <div className="row">
                                <div className="col-4">
                                    <div className="top-bar-item">
                                        <div className="top-bar-icon">
                                            <i className="flaticon-calendar"></i>
                                        </div>
                                        <div className="top-bar-text">
                                            <h3>Opening Hour</h3>
                                            <p>Mon - sat, 8:00 - 9:00</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="top-bar-item">
                                        <div className="top-bar-icon">
                                            <i className="flaticon-call"></i>
                                        </div>
                                        <div className="top-bar-text">
                                            <h3>Call Us</h3>
                                            <p>{info[0]?.phone} 9818591361</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="top-bar-item">
                                        <div className="top-bar-icon">
                                            <i className="flaticon-send-mail"></i>
                                        </div>
                                        <div className="top-bar-text">
                                            <h3>Email Us</h3>
                                            <p>{info[0]?.email} info@saaraconstructions.com</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <!-- Top Bar End --> */}

            {/* <!-- Nav Bar Start --> */}
            <div className="nav-bar">
                <div className="container-fluid">
                    <nav className="navbar navbar-expand-lg bg-dark navbar-dark">
                        <a href="#" className="navbar-brand">SAARA</a>
                        <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse" onClick={toggleNavbar}>
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarCollapse">
                            {user ? (is_admin ? (
                                <div className="navbar-nav">
                                    <a className="nav-item nav-link" href="/admin">Admin</a>
                                    <a className="nav-item nav-link" href="/workers">Workers</a>

                                    <a className="nav-item nav-link" href="/worker-registration">Worker Registration</a>
                                    <a className="nav-item nav-link" href="/attendance">Scan QR</a>
                                </div>

                            ) : (
                                <div className="navbar-nav">
                                    <a className="nav-item nav-link" href="/">Home</a>
                                    <a className="nav-item nav-link" href="/workers">Workers</a>

                                    <a className="nav-item nav-link" href="/worker-registration">Worker Registration</a>
                                    <a className="nav-item nav-link" href="/attendance">Scan QR</a>
                                </div>

                            )) : (
                                <div className="navbar-nav">
                                    <a className="nav-item nav-link" href="/">Home</a>
                                    <a className="nav-item nav-link" href="/about">About</a>
                                    <a className="nav-item nav-link" href="/service">Service</a>
                                    <a className="nav-item nav-link" href="/contact">Contact</a>
                                </div>

                            )}

                            <div className="navbar-nav ms-auto">
                                {!user ? (
                                    <a className="nav-item nav-link" href="/signin">Login</a>
                                ) : (
                                    <div className="profile-wrapper" ref={dropdownRef}>
                                        <img
                                            src={`${IMG_URL}/${previewUrl}`} // Replace with user's profile pic
                                            alt="Profile"
                                            className="profile-img"
                                            onClick={toggleDropdown}
                                        />

                                        {open && (
                                            <div className="profile-dropdown fadeInDown">
                                                <div className="profile-header">
                                                    <input type="file" accept="image/*" ref={fileInputRef} style={{display :"none"}} onChange={handleFileChange}  />
                                                    
                                                        <div onClick={handleImageClick}>
                                                            <img src={`${IMG_URL}/${previewUrl}`}  alt="Preview" width={80} height={80} style={{ borderRadius: '50%' }} />
                                                        </div>
                                                   
                                                    {/* <img
                                                        src="img/icons.png"
                                                        alt="User"
                                                        className="dropdown-avatar"
                                                    /> */}
                                                    <div className='user-info'>
                                                        <div className="user-name">{user.username}</div>
                                                        <a href="#" className="view-profile">View Profile</a>
                                                    </div>
                                                </div>
                                                <div className="dropdown-option">
                                                    <p><span className="icon">⚙️</span>Settings</p>
                                                    
                                                </div>
                                                <div className="dropdown-option">
                                                    <button className="option-text" onClick={logout}>
                                                        <img src='img/image.png' />
                                                        Logout</button>
                                                    <span className="timezone">{timezone}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                        </div>
                    </nav>
                </div>
            </div>
            {/* <!-- Nav Bar End --> */}
        </div>
    )
}

export default Navbar2
